import { Sparkles } from "lucide-react";
import ContentEditor from "@/components/ContentEditor";

export default function AdminHero() {
  return (
    <ContentEditor
      contentKey="hero"
      pageHeading="Ana sayfa açılışını düzenle"
      description="Başlıkta yeni satır için Enter'a bas — canlıda satır sonuna dönüşür."
      icon={Sparkles}
      redirectPath="/"
      successMessage="Ana sayfa güncellendi"
    />
  );
}
